import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Portal from '@atlaskit/portal';
import { layers } from '@atlaskit/theme/constants';
import Modal from './Modal';
import { ModalTransitionConsumer } from './ModalTransition';
import StackConsumer from './StackConsumer';

var ModalWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalWrapper, _React$Component);

  var _super = _createSuper(ModalWrapper);

  function ModalWrapper() {
    var _this;

    _classCallCheck(this, ModalWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onModalClosed", function (onExited) {
      return function (e) {
        if (onExited) {
          onExited();
        }

        if (_this.props.onCloseComplete) {
          _this.props.onCloseComplete(e);
        }
      };
    });

    return _this;
  }

  _createClass(ModalWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(ModalTransitionConsumer, null, function (_ref) {
        var isOpen = _ref.isOpen,
            onExited = _ref.onExited;
        return /*#__PURE__*/React.createElement(Portal, {
          zIndex: layers.modal()
        }, /*#__PURE__*/React.createElement(StackConsumer, {
          isOpen: isOpen
        }, function (naturalStackIndex) {
          return /*#__PURE__*/React.createElement(Modal, _extends({}, _this2.props, {
            isOpen: isOpen,
            stackIndex: _this2.props.stackIndex || naturalStackIndex,
            onCloseComplete: _this2.onModalClosed(onExited)
          }), _this2.props.children);
        }));
      });
    }
  }]);

  return ModalWrapper;
}(React.Component);

_defineProperty(ModalWrapper, "defaultProps", {
  autoFocus: true,
  scrollBehavior: 'inside',
  shouldCloseOnEscapePress: true,
  shouldCloseOnOverlayClick: true,
  isChromeless: false,
  width: 'medium',
  isHeadingMultiline: true,
  onClose: function onClose() {}
});

export default ModalWrapper;